import type { RouterConfig } from '@nuxt/schema';

import { handleCategoryRedirect, filterAutoGeneratedShopRoute, customRoutes } from './router';

export default {
  routes: (_routes) => {
    handleCategoryRedirect(_routes);

    let routes = filterAutoGeneratedShopRoute([..._routes]);
    routes = [...routes, ...customRoutes];

    return routes;
  },
} as RouterConfig;
